import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { ArrowRight, MagnifyingGlass, House } from "@phosphor-icons/react";

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="Page not found"
        description="The page you're looking for doesn't exist."
        url="/404"
      />
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
        <div
          data-testid="not-found-code"
          className="font-display font-black text-[10rem] md:text-[14rem] leading-none tracking-tight text-foreground/10"
        >
          404
        </div>
        <div className="overline text-primary -mt-6">Page not found</div>
        <h1 className="font-display font-black text-4xl md:text-5xl tracking-tight mt-3">
          This page has taken a coffee break.
        </h1>
        <p className="mt-4 text-foreground/70 max-w-xl mx-auto leading-relaxed">
          The URL you followed doesn't exist on Finance Topia. It may have moved,
          the link may be a typo, or the article may have been unpublished.
        </p>

        <div className="mt-10 flex flex-wrap gap-3 justify-center">
          <Link
            to="/"
            data-testid="not-found-home"
            className="inline-flex items-center gap-2 h-12 px-6 bg-foreground text-background font-semibold hover:bg-primary transition-colors duration-200"
          >
            <House size={16} weight="bold" /> Go home
          </Link>
          <Link
            to="/search"
            data-testid="not-found-search"
            className="inline-flex items-center gap-2 h-12 px-6 border border-foreground/25 hover:bg-foreground hover:text-background transition-colors duration-200"
          >
            <MagnifyingGlass size={16} weight="bold" /> Search articles
          </Link>
        </div>

        <div className="mt-16 border-t border-foreground/10 pt-10 text-left">
          <div className="overline mb-4">Or explore a desk</div>
          <ul className="grid gap-2 sm:grid-cols-2">
            {[
              { slug: "investing", name: "Investing" },
              { slug: "personal-finance", name: "Personal Finance" },
              { slug: "cryptocurrency", name: "Cryptocurrency" },
              { slug: "stock-market", name: "Stock Market" },
              { slug: "retirement-planning", name: "Retirement Planning" },
              { slug: "market-analysis", name: "Market Analysis" },
            ].map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/category/${c.slug}`}
                  className="group inline-flex items-center gap-2 text-sm hover:text-primary transition-colors duration-200"
                >
                  {c.name}
                  <ArrowRight size={12} className="group-hover:translate-x-1 transition-transform duration-200" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
